
export default class News {

  public info: string;
  public link: string;
  public putIcon: boolean;
  public alwaysShow: boolean;
  public show: boolean;
  public title?: string;
  public buttonName?: string;


  // <NewsRow info="Dynatrace Extends its Davis AI Engine to Enable Ad Hoc Exploratory Analytics" link="#" putIcon={true} />
  constructor(info: string, link: string, putIcon: boolean, alwaysShow: boolean, show: boolean, title?: string,  buttonName?: string) {
    this.info = info;
    this.link = link;
    this.putIcon = putIcon;
    this.alwaysShow = alwaysShow;
    this.show = show;
    this.title = title;
    this.buttonName = buttonName;
  }

}
